import Clinical from '@assets/clinical.png';
import Plus from '@assets/plus.png';
import { CircleCheck, CircleX } from 'lucide-react';

export function Comparative() {
  return (
    <div className="mb-4 flex flex-row">
      <div className="text-background">
        <div className="mb-2 flex flex-row items-center justify-end gap-x-2">
          <img alt="Imagem plano plus" className="mt-1 h-9 w-14" src={Plus} />
          <img
            alt="Imagem plano clinical"
            className="h-9 w-14"
            src={Clinical}
          />
        </div>

        <div className="flex flex-row justify-between gap-x-1 pr-4">
          <p className="pb-3">Conteúdo direto ao ponto</p>
          <div className="flex flex-row">
            <CircleCheck
              className="fill-success text-primary size-7"
              strokeWidth={1.5}
            />
            <div className="bg-background/30 mx-4 w-px" />
            <CircleCheck
              className="text-primary fill-success size-7"
              strokeWidth={1.5}
            />
          </div>
        </div>

        <div className="flex flex-row justify-between gap-x-1 pr-4">
          <p className="pb-3">Monte e organize seus próprios modelos</p>
          <div className="flex flex-row">
            <CircleCheck
              className="text-primary fill-success size-7"
              strokeWidth={1.5}
            />
            <div className="bg-background/30 mx-4 w-px" />
            <CircleCheck
              className="text-primary fill-success size-7"
              strokeWidth={1.5}
            />
          </div>
        </div>

        <div className="flex flex-row justify-between gap-x-1 pr-4">
          <p className="pb-3">Calculadoras práticas e personalizáveis</p>
          <div className="flex flex-row">
            <CircleCheck
              className="text-primary fill-success size-7"
              strokeWidth={1.5}
            />
            <div className="bg-background/30 mx-4 w-px" />
            <CircleCheck
              className="text-primary fill-success size-7"
              strokeWidth={1.5}
            />
          </div>
        </div>

        <div className="flex flex-row justify-between gap-x-1 pr-4">
          <p className="pb-3">Acesso completo e ilimitado</p>
          <div className="flex flex-row">
            <CircleCheck
              className="text-primary fill-success size-7"
              strokeWidth={1.5}
            />
            <div className="bg-background/30 mx-4 w-px" />
            <CircleX
              className="text-primary fill-destructive size-7"
              strokeWidth={1.5}
            />
          </div>
        </div>

        <div className="flex flex-row justify-between gap-x-1 pr-4">
          <p className="pb-3">Acesso off-line (app)</p>
          <div className="flex flex-row">
            <CircleCheck
              className="text-primary fill-success size-7"
              strokeWidth={1.5}
            />
            <div className="bg-background/30 mx-4 w-px" />
            <CircleX
              className="text-primary fill-destructive size-7"
              strokeWidth={1.5}
            />
          </div>
        </div>

        <div className="flex flex-row justify-between gap-x-1 pr-4">
          <p className="pb-3">Acesso ao GPWhats</p>
          <div className="flex flex-row">
            <CircleCheck
              className="text-primary fill-success size-7"
              strokeWidth={1.5}
            />
            <div className="bg-background/30 mx-4 w-px" />
            <CircleX
              className="text-primary fill-destructive size-7"
              strokeWidth={1.5}
            />
          </div>
        </div>

        <div className="flex flex-row justify-between gap-x-1 pr-4">
          <p className="pb-3">Acesso ao GPChat</p>
          <div className="flex flex-row">
            <CircleCheck
              className="text-primary fill-success size-7"
              strokeWidth={1.5}
            />
            <div className="bg-background/30 mx-4 w-px" />
            <CircleX
              className="text-primary fill-destructive size-7"
              strokeWidth={1.5}
            />
          </div>
        </div>

        <div className="flex flex-row justify-between gap-x-1 pr-4">
          <p className="pb-3">Time de suporte e dúvidas</p>
          <div className="flex flex-row">
            <CircleCheck
              className="text-primary fill-success size-7"
              strokeWidth={1.5}
            />
            <div className="bg-background/30 mx-4 w-px" />
            <CircleX
              className="text-primary fill-destructive size-7"
              strokeWidth={1.5}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
